import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { cn } from '@/utils';

interface ThemeToggleProps {
	className?: string;
	size?: 'default' | 'compact';
}

// const baseToggleButtonClass =
// 	'inline-flex items-center justify-center rounded-full border border-border/60 bg-card/70 p-0 text-foreground shadow-sm transition hover:border-primary/40 hover:bg-card/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2 focus-visible:ring-offset-background';

const baseToggleButtonClass =
	'inline-flex items-center justify-center rounded-full border border-border/60 p-0 shadow-sm transition hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2 focus-visible:ring-offset-background';

export function ThemeToggle({ className, size = 'default' }: ThemeToggleProps) {
	const { setTheme, resolvedTheme } = useTheme();
	const [mounted, setMounted] = useState(false);

	// Only render after mounting to avoid hydration mismatch
	useEffect(() => {
		setMounted(true);
	}, []);

	const dimensionClass = size === 'compact' ? 'h-9 w-9' : 'h-11 w-11';
	const iconSizeClass = size === 'compact' ? 'h-[1.1rem] w-[1.1rem]' : 'h-[1.2rem] w-[1.2rem]';
	const buttonClassName = cn(baseToggleButtonClass, dimensionClass, className);

	if (!mounted) {
		return (
			<Button variant="primary" className={cn(buttonClassName)} aria-label="Toggle theme">
				<Sun className={iconSizeClass} />
			</Button>
		);
	}

	const isDark = resolvedTheme === 'dark';

	return (
		<Button variant="primary" onClick={() => setTheme(isDark ? 'light' : 'dark')} className={buttonClassName} aria-label="Toggle theme">
			<Sun className={cn('transition-all duration-300', iconSizeClass, isDark ? 'rotate-90 scale-0' : 'rotate-0 scale-100')} />
			<Moon
				className={cn(
					'absolute transition-all duration-300 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
					iconSizeClass,
					isDark ? 'rotate-0 scale-100' : '-rotate-90 scale-0',
				)}
			/>
			<span className="sr-only">Toggle theme</span>
		</Button>
	);
}
